import React from 'react';
import { withAnalytics } from '../with-analytics';
import { onDismissed } from '../events';

interface Props {
	isExpanded: boolean;
	onDialogClosed: (activeProduct: string) => any;
	activeProduct: string;
}

export class DialogDismissedHandlerComponent extends React.Component<Props> {
	componentDidUpdate(prevProps: Props) {
		const { onDialogClosed, isExpanded, activeProduct } = this.props;

		if (prevProps.isExpanded && !isExpanded) {
			onDialogClosed(activeProduct);
		}
	}

	render() {
		return null;
	}
}

export const DialogDismissedHandler = withAnalytics({
	onDialogClosed: onDismissed,
})(DialogDismissedHandlerComponent);
